"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seven/sections/blogSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BlogSection46sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/blog/blog-14.jpg" | "/Templates/Doccure/img/blog/blog-15.jpg" | "/Templates/Doccure/img/blog/blog-16.jpg" */
    src: string;
    /** Detected variants: "Wellness" | "Heart Health" | "Lifestyle" */
    link0Text: ReactNode;
    /** Detected variants: "29, Nov 2026" | "25, Nov 2026" | "18, Nov 2026" */
    p0Text: ReactNode;
    /** Detected variants: "What Really Causes Heart Attacks? A Simple Explanation" | "Early Signs of Heart Failure You Shouldn’t Ignore" | "Cholesterol & Your Heart What Actually Happens Inside" */
    link0Link0Text: ReactNode;
    /** Detected variants: "col-xl-4 col-md-6 d-flex" */
    className?: string;
    /** Detected variants: "blog-item-seven flex-fill wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "blog-img" */
    div0ClassName2?: string;
    /** Detected variants: "all_routes.blogDetails" */
    href?: string;
    /** Detected variants: "blog" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "blog-content" */
    div1ClassName?: string;
    /** Detected variants: "blog-info" */
    div0ClassName3?: string;
    /** Detected variants: "badge" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    link0Href?: string;
    /** Detected variants: "date" */
    p0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.blogDetails" */
    link0Href2?: string;
    /** Detected variants: "" */
    div0div1h30Link0Expr1?: ReactNode;
};
export type HomeSevenBlogSectionGeneratedProps = {
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection46sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "Latest Articles" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Latest Trends &" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Insights" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "all_routes.blogGrid" */
    sectionDiv0Div2Link0LinkHref?: string;
    /** Default: "View All Blogs" */
    sectionDiv0Div2Link0LinkText?: ReactNode;
    sectionDiv0Div2Link0LinkVisible?: boolean;
    sectionDiv0Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/blog-bg-01.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/blog-bg-02.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    blogSection46s: BlogSection46sItem[];
    blogSection46sItemWrapper?: (item: BlogSection46sItem, content: ReactNode) => ReactNode;
    blogSection46sRenderer?: (defaultNode: ReactNode) => ReactNode;
    blogSection46sLinkVisible?: boolean;
    blogSection46sLinkRenderer?: (item: BlogSection46sItem, defaultNode: ReactNode) => ReactNode;
    blogSection46sImageVisible?: boolean;
    blogSection46sImageRenderer?: (item: BlogSection46sItem, defaultNode: ReactNode) => ReactNode;
    blogSection46sH3Visible?: boolean;
    blogSection46sH3Renderer?: (item: BlogSection46sItem, defaultNode: ReactNode) => ReactNode;
    blogSection46sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    blogSection46sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    blogSection46sH3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection46sItem) => Partial<ComponentProps<"h3">>);
};

const HomeSevenBlogSectionGenerated: FC<HomeSevenBlogSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Latest Articles",
    sectionDiv0Div0H20H2Text = "Latest Trends &",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Insights",
    sectionDiv0Div2Link0LinkHref = "all_routes.blogGrid",
    sectionDiv0Div2Link0LinkText = "View All Blogs",
    sectionDiv0Div2Link0LinkVisible,
    sectionDiv0Div2Link0LinkRenderer,
    sectionDiv0Div2Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/blog-bg-01.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/blog-bg-02.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    blogSection46s,
    blogSection46sItemWrapper,
    blogSection46sRenderer,
    blogSection46sLinkVisible,
    blogSection46sLinkRenderer,
    blogSection46sImageVisible,
    blogSection46sImageRenderer,
    blogSection46sH3Visible,
    blogSection46sH3Renderer,
    blogSection46sLinkProps,
    blogSection46sImageProps,
    blogSection46sH3Props,
}) => {
    return (
        <section className="blog-section-seven section">
            <div className="container">
                <div className="section-header section-header-seven text-center">
                    <div className="section-sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row justify-content-center g-4"}>
                    {renderCollectionNode(
                        blogSection46s,
                        (item: BlogSection46sItem) => (
                            <div className={item.className ?? "col-xl-4 col-md-6 d-flex"} key={item.key}>
                                <div className={item.div0ClassName ?? "blog-item-seven flex-fill wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                    <div className={item.div0ClassName2 ?? "blog-img"}>
                                        {renderItemNode(blogSection46sLinkVisible, blogSection46sLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "all_routes.blogDetails"} {...(typeof blogSection46sLinkProps === "function" ? blogSection46sLinkProps(item) : (blogSection46sLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                {renderItemNode(blogSection46sImageVisible, blogSection46sImageRenderer, item, (
                                                    <SmartImage className={item.imageWithBasePath0ClassName ?? "img-fluid"} src={item.src} alt={item.alt ?? "blog"} {...(typeof blogSection46sImageProps === "function" ? blogSection46sImageProps(item) : (blogSection46sImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "blog-content"}>
                                        {renderItemNode(blogSection46sH3Visible, blogSection46sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof blogSection46sH3Props === "function" ? blogSection46sH3Props(item) : (blogSection46sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(blogSection46sLinkVisible, blogSection46sLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href2 ?? "all_routes.blogDetails"} {...(typeof blogSection46sLinkProps === "function" ? blogSection46sLinkProps(item) : (blogSection46sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>
                                                        {item.link0Link0Text}
                                                        {" "}
                                                    </SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <div className={item.div0ClassName3 ?? "blog-info"}>
                                            {renderItemNode(blogSection46sLinkVisible, blogSection46sLinkRenderer, item, (
                                                <SmartLink href={item.link0Href ?? "#"} className={item.link0ClassName ?? "badge"} {...(typeof blogSection46sLinkProps === "function" ? blogSection46sLinkProps(item) : (blogSection46sLinkProps ?? {}))} {...(typeof divDiv0Div1Div0Link0LinkProps === "function" ? divDiv0Div1Div0Link0LinkProps(item) : (divDiv0Div1Div0Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                            ))}
                                            <p className={item.p0ClassName ?? "date"}>{item.p0Text}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ),
                        blogSection46sItemWrapper,
                        blogSection46sRenderer
                    )}
                </div>
                <div className="more-btn text-center">
                    {renderNode(sectionDiv0Div2Link0LinkVisible, sectionDiv0Div2Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div2Link0LinkHref} className="btn btn-white theme-7-btn" {...(sectionDiv0Div2Link0LinkProps ?? {})}>
                            {sectionDiv0Div2Link0LinkText}
                            <span className="icon">
                                <i className="isax isax-arrow-right-3" />
                            </span>
                        </SmartLink>
                    ))}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="blog-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="blog-bg-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSevenBlogSectionGenerated;
